module.exports = __webpack_public_path__ + "static/media/mouthUpperUpLeft.d6668dd2.obj";